import { useQuery, useLazyQuery } from "@apollo/client";
import {
  GET_CALL_BY_USER,
  EXPORT_CALLS_DETAILS_BY_USER,
  GET_CALL_DETAILS_BY_ID,
  GET_LEAD_DETAIL_CLICK,
} from "../../graphql/query";
import { useReportDateFilter } from "../../context/ReportDateFilterContext";
import { CUSTOM, LAST_30_DAYS } from "../../constant/ReportConstants";

import { formatReportRangeDate } from "../../utils/formatters";
// Custom hook to fetch call data by user
export const useCallByUser = (userId = null, extraVars = {}) => {
  const { dateFilter, dateRange } = useReportDateFilter();

  const { data, loading, error, refetch } = useQuery(GET_CALL_BY_USER, {
    fetchPolicy: "network-only",
    variables: {
      userId,
      filterType: (dateFilter || LAST_30_DAYS).toUpperCase(),
      dateRange:
        dateRange && dateFilter === CUSTOM
          ? [
              dateRange[0] ? formatReportRangeDate(dateRange[0]) : null,
              dateRange[1] ? formatReportRangeDate(dateRange[1], true) : null,
            ]
          : null,
      ...extraVars,
    },
    skip: !dateFilter || (dateFilter === CUSTOM && (!dateRange || !dateRange[0] || !dateRange[1])),
  });

  return { data, loading, error, refetch };
};

// Custom hook to export call details by user
export const useExportCallDetailsByUser = (userId = null, extraVars = {}) => {
  const { dateFilter, dateRange } = useReportDateFilter();

  const [fetchExportCallDetailByUser, { data, loading, error, called }] = useLazyQuery(
    EXPORT_CALLS_DETAILS_BY_USER,
    {
      fetchPolicy: "network-only",
      variables: {
        userId,
        filterType: (dateFilter || LAST_30_DAYS).toUpperCase(),
        dateRange:
          dateRange && dateFilter?.toLowerCase() === CUSTOM
            ? [
                dateRange[0] ? formatReportRangeDate(dateRange[0]) : null,
                dateRange[1] ? formatReportRangeDate(dateRange[1]) : null,
              ]
            : null,
        ...extraVars,
      },
      skip:
        !dateFilter ||
        (dateFilter?.toLowerCase() === CUSTOM && (!dateRange || !dateRange[0] || !dateRange[1])),
    }
  );

  return { fetchExportCallDetailByUser, data, loading, error, called };
};

// Custom hook to fetch call details by call ID
export const useCallDetailById = (callId, callSid) => {
  const [fetchCallDetailsbyId, { data, loading, error, refetch }] = useLazyQuery(
    GET_CALL_DETAILS_BY_ID,
    {
      fetchPolicy: "network-only",
      variables: {
        callId,
        callSid,
      },
      skip: !callId && !callSid,
    }
  );

  return { fetchCallDetailsbyId, data, loading, error, refetch };
};

// Custom hook to track lead detail clicks
export const useLeadDetailClick = leaId => {
  const [fetchLeadDetailClick, { data, loading, error }] = useLazyQuery(GET_LEAD_DETAIL_CLICK, {
    fetchPolicy: "network-only",
    variables: {
      leadId: leaId, // Pass the lead ID to the query
    },
  });

  return { fetchLeadDetailClick, data, loading, error };
};
